<div class="copy-code-container" [ngClass]="(isNoVoucherCode) ? 'justify-center':'justify-end'">
    <ng-container *ngIf="!isNoVoucherCode">
    <span class="copy-code-title">{{title}}</span>
    <div class="copy-code-value">:  {{value}}</div>
    <!-- <div class="flex-fill"></div> -->
    <img class="pointer" (click)="copyContent();$event.stopPropagation()" [src]="assetsPath+'/svg/copy.svg'" alt="copy">
    </ng-container>
    <ng-container *ngIf="isNoVoucherCode">
        <div class="copy-code-value no-voucher">No Voucher code Required</div>
    </ng-container>

</div>
